module.exports = __webpack_public_path__ + "img/bg.13e7a458.png";